import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=5b04174a&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=5b04174a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04174a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b04174a')) {
      api.createRecord('5b04174a', component.options)
    } else {
      api.reload('5b04174a', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=5b04174a&scoped=true&", function () {
      api.rerender('5b04174a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4UfWXvoJAPHDf/JS/comp/DateRange.vue"
export default component.exports